module.exports = "/_next/static/resources/photo-1-4ebf0501966517706ed8bfd552ff9388.webp";